module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/4/3-82b80116f53b5e0fc87c504709d9a5df.jpg";